export default {
    "subscribeEmailToNewsletter": "bd6b10c10f2931ee8388c7a26b4b46836e3bc54bfa701f328401f27b9037d2ce"
};
